import React from "react";

//Import Breadcrumb
import { FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { Icon } from "@iconify/react/dist/iconify.js";

const RadioButtonGroupInGrid = ({
    title,
    error,
    data,
    setValue,
    isOptional,
    name,
    value,
    disabled,
    sm,
    xs,
    valueName = "value",
    labelName = "label",
}) => {
    return (
        <React.Fragment>
            <FormControl variant="outlined" fullWidth error={error ? true : false} disabled={disabled}>
                {title && <FormLabel style={{ fontFamily: 'FunnelSans', fontWeight: 500, fontSize: 14, margin: 0, color: "#1D1B1B", justifyContent: "space-between", display: "flex" }}>{title} {isOptional ? <span className="optional-label">Optional</span> : null}</FormLabel>}
                <RadioGroup
                    row
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue=""
                    value={value}
                    name={name}
                    style={{ fontFamily: 'FunnelSans' }}
                    onChange={(e) => disabled ? "" : setValue(e.target.value)}

                >
                    <Grid container>
                        {
                            data && data.length > 0 && data.map((x, idx) =>
                                <Grid item xs={xs || 12} sm={sm || 6} key={x?.[valueName] ?? idx}>
                                    <FormControlLabel value={x?.[valueName]} style={{ fontFamily: 'FunnelSans', fontSize: 14, marginBottom: 0 }}
                                        disabled={disabled}
                                        control={<Radio error={error ? true : false}
                                            disabled={disabled}
                                            sx={{
                                                '&.Mui-checked': {
                                                    color: disabled ? "#9e9e9e" : "#1D1B1B",
                                                },
                                                '& .MuiSvgIcon-root': {
                                                    fontSize: 18,
                                                },

                                            }} />}
                                        label={
                                            <>
                                                <div style={{ fontFamily: 'FunnelSans', fontSize: 14, color: disabled ? "#9e9e9e" : "#1D1B1B" }}>{x?.[labelName]}</div>
                                                {
                                                    x?.description && <div style={{ fontSize: 13, color: disabled ? "#bdbdbd" : '#74788D', marginTop: '5px', fontWeight: '300' }}>{x.description}</div>
                                                }
                                            </>
                                        }
                                    />
                                </Grid>
                            )
                        }
                    </Grid>
                </RadioGroup>
            </FormControl>
            {error && <FormHelperText sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={16} width={16} />{error || ""}</FormHelperText>}

        </React.Fragment >
    );
};

export default RadioButtonGroupInGrid;
